var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AboutUsheader'),_c('AboutUs'),_c('AboutUsTeam'),_c('AboutUSPartner'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }